import type { schemaType as homeSchemaType } from '~/modules/api/strapi/home/schema'
import type { propsInterface } from '~/modules/design-system/sections/s-media-banner/s-media-banner.vue'

export const useToSMediaBanner = () => {
  const fromStrapiHome = (data: homeSchemaType): propsInterface | null => {
    if (data.attributes.media_banner) {
      const mediaBanner: propsInterface = {
        title: data.attributes.media_banner.title,
        subtitle: data.attributes.media_banner.subtitle,
        text: data.attributes.media_banner.text,
        image: data.attributes.media_banner.image.data?.attributes.url,
        button: data.attributes.media_banner.button,
        youtubeUrl: data.attributes.media_banner.youtube_url,
      }
      return mediaBanner
    }
    return null
  }

  return { fromStrapiHome }
}
